const DeliveryPartnerAttachments = [
  {
    name: "Official Application Letter",
    description: "Official Application Letter",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Track Record",
    description: "Track Record ",
    is_mandatory: true,
    info: "share information about environmental related projects implemented by your organization",
  },
  {
    name: "Legal Status Document",
    description: "Legal Status Document",
    is_mandatory: true,
    info: "",
  },
]

export default DeliveryPartnerAttachments
